export const LOGOS_LABELS_FILTER_STORAGE_KEY = 'media-manager:logos:labels-filter';

export function readStoredLogosLabelsFilter(): string[] {
  try {
    const raw = localStorage.getItem(LOGOS_LABELS_FILTER_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function writeStoredLogosLabelsFilter(labels: string[]): void {
  try {
    localStorage.setItem(LOGOS_LABELS_FILTER_STORAGE_KEY, JSON.stringify(labels));
  } catch {
    // ignore quota / disabled storage
  }
}
